import { NgModule } from '@angular/core';
import { I18nModule, UrlModule } from "@spartacus/core";
import { GenCheckoutDelegoComponent } from "./checkout-delego/checkout-delego.component";
import { AsyncPipe, CommonModule, NgIf } from "@angular/common";
import { AtMessageModule, CardModule, FormErrorsModule, IconModule, KeyboardFocusModule, PromotionsModule, SpinnerModule } from "@spartacus/storefront";
import { GenOrderService } from '../../services/order.service';
import { GenOrderSummaryComponent } from '../../shared/components/order-summary/order-summary.component';
import { GenCheckoutSpecialHandlingComponent } from './checkout-special-handling/checkout-special-handling.component';
import { GenCheckoutSingleConsignmentComponent } from './checkout-single-consignment/checkout-single-consignment.component';
import { GenCheckoutOutOfStockDialogComponent } from './checkout-service-parts/checkout-out-of-stock-dialog/checkout-out-of-stock-dialog.component';
import { GenCheckoutServicePartsComponent } from './checkout-service-parts/checkout-service-parts.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GenCheckoutScheduleReplenishmentOrderComponent } from './checkout-schedule-replenishment-order/checkout-schedule-replenishment-order.component';
import { GenCheckoutShippingAccountsSelectorComponent } from './checkout-service-parts/checkout-shipping-accounts-selector/checkout-shipping-accounts-selector.component';
import { GenCheckoutFinishedGoodsComponent } from './checkout-finished-goods/checkout-finished-goods.component';
import { GenCheckoutControlBtnsComponent } from './checkout-control-btns/checkout-control-btns.component';
import { GenCheckoutDeliveryGroupsComponent } from '../../shared/components/checkout-delivery-groups/checkout-delivery-groups.component';
import { GenCheckoutDeliveryMethodSelectorComponent } from './checkout-service-parts/checkout-delivery-method-selector/checkout-delivery-method-selector.component';
import { GenCheckoutDeliveryAddressComponent } from './checkout-delivery-address/checkout-delivery-address.component';
import { GenAddressDetailsFormComponent } from './checkout-delivery-address/address-details/address-details-form/address-details-form.component';
import { GenAddressDetailsComponent } from './checkout-delivery-address/address-details/address-details.component';
import { GenFFMixedCartDialogComponent } from './checkout-delivery-address/ff-mixed-cart-dialog/ff-mixed-cart-dialog.component';
import { GenSplitPaymentDialogComponent } from './checkout-delivery-address/split-payment-dialog/split-payment-dialog.component';
import { GenVerifyAddressComponent } from './checkout-delivery-address/verify-address/verify-address.component';
import { GenAddressValidationService } from '../../services/address-validation.service';
import { GenCheckoutService } from '../../services/checkout.service';
import { GenCartSharedModule } from '../cart/cart-shared/cart-shared.module';
import { GenFreightForwardFormComponent } from './checkout-delivery-address/freight-forward-form/freight-forward-form.component';
import { GenAddressFormComponent } from '../../shared/components/address-form/address-form.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatExpansionModule } from '@angular/material/expansion';
import { GenSharedModule } from '../../shared/shared.module';
import { GenCheckoutReviewSubmitComponent } from './checkout-review-submit/checkout-review-submit.component';
import { GenShippingGroupsComponent } from '../../shared/components/shipping-groups/shipping-groups.component';
import { RouterModule } from '@angular/router';
import { GenCheckoutPlaceOrderComponent } from './checkout-place-order/checkout-place-order.component';
import { GenCheckoutPaymentTypeComponent } from './checkout-payment-type/checkout-payment-type.component';
import { GenMessageComponent } from '../../shared/components/message/message.component';
import { GenInfoMessageComponent } from '../../shared/components/info-message/info-message.component';
import { GenOfflineBadgeComponent } from '../../shared/components/offline-badge/offline-badge.component';
import { GenCheckoutEngineReplacementFormComponent } from './checkout-engine-replacement-form/checkout-engine-replacement-form.component';
import { GenBuilderProgramFileUploadComponent } from './builder-program-file-upload/builder-program-file-upload.component';

@NgModule({
  declarations: [
    GenCheckoutDelegoComponent,
    GenCheckoutFinishedGoodsComponent,
    GenCheckoutServicePartsComponent,
    GenCheckoutOutOfStockDialogComponent,
    GenCheckoutSpecialHandlingComponent,
    GenCheckoutDeliveryAddressComponent,
    GenAddressDetailsComponent,
    GenAddressDetailsFormComponent,
    GenVerifyAddressComponent,
    GenCheckoutPlaceOrderComponent,
    GenCheckoutReviewSubmitComponent,
    GenSplitPaymentDialogComponent,
    GenFFMixedCartDialogComponent,
    GenCheckoutPaymentTypeComponent,
    GenCheckoutEngineReplacementFormComponent,
    GenBuilderProgramFileUploadComponent,
  ],
  imports: [
    GenCheckoutControlBtnsComponent,
    GenCheckoutDeliveryMethodSelectorComponent,
    GenFreightForwardFormComponent,
    GenCheckoutShippingAccountsSelectorComponent,
    GenCheckoutSingleConsignmentComponent,
    GenOrderSummaryComponent,
    GenCheckoutScheduleReplenishmentOrderComponent,
    GenShippingGroupsComponent,
    PromotionsModule,
    UrlModule,
    RouterModule,
    CardModule,
    GenCheckoutDeliveryGroupsComponent,
    GenCartSharedModule,
    GenAddressFormComponent,
    GenSharedModule,
    MatExpansionModule,
    NgSelectModule,
    AsyncPipe,
    NgIf,
    SpinnerModule,
    IconModule,
    CommonModule,
    ReactiveFormsModule,
    GenInfoMessageComponent,
    IconModule,
    GenOfflineBadgeComponent,
    I18nModule,
    AtMessageModule,
    CommonModule,
    KeyboardFocusModule,
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    FormErrorsModule,
    GenMessageComponent,
  ],
  providers: [
    GenCheckoutService,
    GenOrderService,
    GenAddressValidationService,
  ],
  exports: [
    GenCheckoutControlBtnsComponent,
    GenCheckoutDelegoComponent,
    GenCheckoutDeliveryAddressComponent,
    GenCheckoutDeliveryGroupsComponent,
    GenCheckoutFinishedGoodsComponent,
    GenCheckoutSingleConsignmentComponent,
    GenCheckoutScheduleReplenishmentOrderComponent,
    GenCheckoutPlaceOrderComponent,
    GenCheckoutServicePartsComponent,
    GenCheckoutOutOfStockDialogComponent,
    GenCheckoutSpecialHandlingComponent,
    GenOrderSummaryComponent,
    GenCheckoutPaymentTypeComponent,
    GenCheckoutEngineReplacementFormComponent,
  ]
})
export class GenCheckoutModule { }
